var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6029 93.599C105.974 93.599 116.003 73.5416 116.003 48.7995C116.003 24.0574 105.974 4 93.6029 4C81.2318 4 71.2031 24.0574 71.2031 48.7995C71.2031 73.5416 81.2318 93.599 93.6029 93.599Z",
    stroke: "#062F85",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.599 4C76.2224 4 40.2036 17.3167 19.5174 25.5822C10.0423 29.3677 4 38.5964 4 48.7995C4 59.0026 10.0479 68.2313 19.5174 72.0168C40.2036 80.2824 76.2224 93.599 93.599 93.599M54.3994 115.999L43.5188 110.007C37.7099 106.792 32.9979 101.91 29.9913 95.9903C26.9847 90.071 25.8215 83.3863 26.6518 76.7992",
    stroke: "#062F85",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmDev);
export default __webpack_public_path__ + "static/media/dm-dev.12547011998d1a69a3bafe83fc6c6994.svg";
export { ForwardRef as ReactComponent };